
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { MapPin } from "lucide-react";

interface LocationPermissionDialogProps {
  isOpen: boolean;
  onEnableLocation: () => void;
  onNotNow: () => void;
  onDontAskAgain: () => void;
}

const LocationPermissionDialog = ({
  isOpen,
  onEnableLocation,
  onNotNow,
  onDontAskAgain
}: LocationPermissionDialogProps) => {
  const [dontAskAgain, setDontAskAgain] = useState(false);

  const handleNotNow = () => {
    if (dontAskAgain) {
      onDontAskAgain();
    } else {
      onNotNow();
    }
  };

  const handleEnableLocation = () => {
    onEnableLocation();
    if (dontAskAgain) {
      onDontAskAgain();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
              <MapPin className="w-6 h-6 text-primary" />
            </div>
            <div>
              <DialogTitle className="text-left">Enable Location Access</DialogTitle>
              <DialogDescription className="text-left">
                Get better matches by allowing location access
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>
        
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Allow location access to see users near you and get accurate distances for better matching.
          </p>
          
          <div className="flex flex-col gap-3">
            <Button 
              onClick={handleEnableLocation}
              className="w-full h-12 text-base font-semibold"
              size="lg"
            >
              Enable Location
            </Button>
            
            <Button 
              onClick={handleNotNow}
              variant="outline"
              className="w-full"
            >
              Not Now
            </Button>
          </div>

          <div className="flex items-center space-x-2 pt-2">
            <Checkbox 
              id="dont-ask-again"
              checked={dontAskAgain}
              onCheckedChange={(checked) => setDontAskAgain(checked as boolean)}
            />
            <label 
              htmlFor="dont-ask-again"
              className="text-sm text-muted-foreground cursor-pointer"
            >
              Don't ask again
            </label>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LocationPermissionDialog;
